import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import PageSection from '../../common/PageSection';
import PageLoadingSpinner from '../../app/Pages/PageLoadingSpinner';
import { apiPage } from '../../../actions/Api/Page/apiPage';
import AgreementCheckTypeTable from '../Tables/AgreementCheckTypeTable';
import { useAgreementCheckTypeStore } from '../Provider/useAgreementCheckTypeStore';

export default function AgreementCheckTypesPageContent() {
    const { goBack } = useHistory();
    const updateCheckTypesFromFetch = useAgreementCheckTypeStore(state => state.updateDataFromFetch);
    const dispatch = useDispatch();

    //fetch page
    useEffect(() => {
        dispatch(apiPage('agreement-checks'))
            .then(response => {
                updateCheckTypesFromFetch(response.agreementCheckTypes || [], true);
            })
            .catch(err => console.error('error', err));
    }, [updateCheckTypesFromFetch, dispatch]);

    return (
        <PageSection onBackClicked={goBack} title="Checks" titleExtra={<PageLoadingSpinner />}>
            <AgreementCheckTypeTable />
        </PageSection>
    );
}
